// removed by extract-text-webpack-plugin
module.exports = {"alert":"_3eskO","title":"mmpDo","body":"_3XE7v","bodyWithTextarea":"ba-st","buttonContainer":"_1UoVe","button":"_3dAVz","confirmButton":"FPZgF _3dAVz","cancelButton":"_2uDOI _3dAVz","textarea":"_2ReD5"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Alert/index.sass
// module id = 1457
// module chunks = 1